var _defs, _path, _path2, _path3, _rect, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifestyle745B575(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:none;stroke:#4d535b;stroke-miterlimit:10}.cls-4{stroke-width:2.1px}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.2h34.7V53a4 4 0 01-4 4H16a4 4 0 01-4-4V20.2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.2v4.2h30.5v31.5c0 .4-.1.7-.1 1 1.8-.4 4.3-2.1 4.3-4.1V20.2z",
    fill: "#dee0e2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13 20.2h32.7a1 1 0 011 1V52a5 5 0 01-5 5H17a5 5 0 01-5-5V21.2a1 1 0 011-1zm8.5 0v8.4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 29.1,
    width: 9.5,
    height: 11.56,
    rx: 1,
    strokeWidth: 2.23,
    fill: "none",
    stroke: "#4d535b",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 29.1,
    width: 9.5,
    height: 11.56,
    rx: 1,
    style: {
      mixBlendMode: "darken"
    },
    fill: "#a1f4c0"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.7 28.6a9.5 9.5 0 010 18.9m-16.8-42V16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 7.6V16M23.6 7.6V16",
    strokeWidth: 1.88,
    fill: "none",
    stroke: "#4d535b",
    strokeMiterlimit: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyle745B575);
export default __webpack_public_path__ + "static/media/lifestyle.745b575.112b3486a64f63e20027ede2ce43108f.svg";
export { ForwardRef as ReactComponent };